export const USER_REVISION_CHECK_REFRESH = 5000;
